<template>
    <div class="d-flex">
        <font-awesome-icon
            v-for="i in filledStars"
            :key="i"
            :icon="['fas', 'star']"
        />
        <font-awesome-icon
            v-for="i in emptyStars"
            :key="i"
            :icon="['far', 'star']"
        />
    </div>
</template>

<script>
export default {
    computed: {
        filledStars() {
            return this.params.data
                ? Array.from(
                      { length: this.params.data.stars },
                      (v, k) => k + 1
                  )
                : [];
        },
        emptyStars() {
            return this.filledStars.length
                ? Array.from({ length: 5 - this.filledStars.length })
                : 5;
        },
    },
};
</script>

<style>
</style>